import { z } from "zod";

const observacaoFormSchema = z.object({
  observation: z
    .string()
    .min(5, "A observação deve ter pelo menos 5 caracteres.")
    .max(500, "A observação pode ter no máximo 500 caracteres."),
});

type ObservacaoFormData = z.infer<typeof observacaoFormSchema>;

export type { ObservacaoFormData };
export { observacaoFormSchema };
